// Keep track of callback references to properly clean them up
let notificationCallbacks: {
  isAvailable?: Function;
  isSubscribed?: Function;
  subscribe?: Function;
  unsubscribe?: Function;
} = {};

export function checkAvailbility() {
  if (!import.meta.client || !window || !window.exponea) return;

  // Store the callback reference for cleanup
  const callback = (status: boolean) => {
    if (status) {
      updateStatus();
    }
  };

  notificationCallbacks.isAvailable = callback;
  window.exponea.notifications?.isAvailable(callback);
}

export function updateStatus() {
  if (!import.meta.client || !window || !window.exponea) return;

  // Store the callback reference for cleanup
  const callback = (subscriptionActive: boolean, notificationsDenied: boolean) => {
    if (subscriptionActive || notificationsDenied) return;
    subscribe();
  };

  notificationCallbacks.isSubscribed = callback;
  window.exponea.notifications?.isSubscribed(callback);
}

export function subscribe() {
  if (!import.meta.client || !window || !window.exponea) return;

  // Store the callback reference for cleanup
  const callback = (status: string) => {
    updateStatus();
  };

  notificationCallbacks.subscribe = callback;
  window.exponea.notifications?.subscribe(callback);
}

export function unsubscribe() {
  if (!import.meta.client || !window || !window.exponea) return;

  // Store the callback reference for cleanup
  const callback = (status: boolean) => {
    updateStatus();
  };

  notificationCallbacks.unsubscribe = callback;
  window.exponea.notifications?.unsubscribe(callback);
}

// Add a cleanup function to remove all event listeners and references
export function cleanup() {
  if (!import.meta.client || !window || !window.exponea) return;

  // Clear all stored callbacks
  notificationCallbacks = {};

  // If exponea has a cleanup method, call it
  if (window.exponea.notifications?.cleanup) {
    window.exponea.notifications.cleanup();
  }
}
